import styled from "styled-components";

export const FraudSettingStyle = styled.div`
  .tableHeader{
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .table-container {
    height: auto;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
  }
  .table {
    color: #909294;
    width: 100%;
    min-width: 600px;
  }
  th,
  td {
    width: 20%;
    text-align: center;
    border: none;
    padding: 3px 0;
  }
  .header {
    background: #b6b6b61f;
  }
  .pageName {
    min-width: 300px;
  }
  tbody .pageName {
    text-align: left;
    padding-left: 20px;
  }
  .loader {
    align-items: center;
    height: 75vh;
    left: 50%;
    position: absolute;
  }
  .form-control {
    max-width: 50%;
    min-width: 60px;
    margin: auto;
    text-align: center;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;
